module.exports = __webpack_public_path__ + "static/media/step-5.b6c782aa.svg";